/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Custompropertyinternalname3Inputs */

const en_entity_custompropertyinternalname3 = /** @type {(inputs: Entity_Custompropertyinternalname3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Custom Property Internal Name`)
};

const de_entity_custompropertyinternalname3 = /** @type {(inputs: Entity_Custompropertyinternalname3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Custom Property Interner Name`)
};

/**
* | output |
* | --- |
* | "Custom Property Internal Name" |
*
* @param {Entity_Custompropertyinternalname3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_custompropertyinternalname3 = /** @type {((inputs?: Entity_Custompropertyinternalname3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Custompropertyinternalname3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_custompropertyinternalname3(inputs)
	return de_entity_custompropertyinternalname3(inputs)
});
export { entity_custompropertyinternalname3 as "entity_customPropertyInternalName" }